<template>
    <div class="pielayout">
        <div class="selects">
            <el-select v-model="opctionValue" placeholder="请选择年份" @change="selectChange">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </div>
        <!-- 饼图图表 -->
        <div id="piechars" ref="piechars">
            
        </div>
    </div>
</template>

<script>
import apiUtil from '@/utils/apiUtil'
import apiConst from '@/consts/apiConst'
export default {
  data(){
    return {
        nameList:[],
        options: [],
        opctionValue: '',
        piechartData: {},
    }
  },
  props: ['echartdata'],
  created() {
  },
  mounted(){
    for (let i = 2010; i <= new Date().getFullYear(); i++) {
      this.options.push({ value: i })
    }
    this.opctionValue = this.options[this.options.length - 1].value;
    if(this.echartdata){
        this.opctionValue = this.echartdata.year
        this.piechartData = this.echartdata
        this.drawChart()
        // this.selectChange()
    }
  },
  methods:{
    async selectChange(){
        let pieData = await apiUtil.get(apiConst.pieData,{id: this.$route.query.cate_id, year:this.opctionValue});
        if (pieData) {
            console.log('----1')
            this.piechartData = pieData.piedata;
            this.drawChart()
        } else {
            console.log('222')
            pieData = await apiUtil.get(apiConst.pieData,{id: this.$route.query.cate_id, year:this.opctionValue - 1});
        }
    },
    drawChart(){
        let lineChart = this.$echarts.init(this.$refs.piechars);
        let option = {
            grid: {
                top: '8%',
                left: '5%',
                right: '8%',
                bottom: '5%',
                containLabel: true
            },
            title: {
                text: '',
                subtext: '建筑市场走势',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: this.piechartData.lData
            },
            series: [
                {
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: this.piechartData.sData,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        // 绘制图表
        lineChart.setOption(option);
    }
  }

}
</script>

<style  lang="stylus" scoped>
.pielayout{
    .selects{
        display: flex;
        justify-content: center;
        margin-top: 30px;
    }
    .selects /deep/ .el-input__inner{
        height: 60px;
        border-radius: 30px;
        font-size: 20px;
    }
    .el-select-dropdown__item{
      font-size: 20px;
    }
    #piechars{
        height:500px;
        background-image:url('../assets/images/data/waterbg.png')
    }
}
</style>
<style>

</style>